import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en.json' with { type: 'json' };
import ruCommon from './locales/ru.json' with { type: 'json' };

export async function initI18n(): Promise<void> {
  await i18next.use(initReactI18next).init({
    resources: {
      ru: { translation: ruCommon },
      en: { translation: enCommon },
    },
    lng: localStorage.getItem('inbx_locale') ?? 'ru',
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
  });
}
